module.exports = __webpack_public_path__ + "img/ji.dfa36f84.png";